import { motion } from "framer-motion";
import { WhatsappLogo, ArrowRight, Phone, MapPin, NavigationArrow } from "@phosphor-icons/react";
import { IMAGES, COMPANY, WHATSAPP_QUOTE_URL } from "@/data/site";

const FinalCTA = () => {
  const { address } = COMPANY;

  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-28 overflow-hidden"
      style={{
        backgroundImage: `url(${IMAGES.finalCta})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed"
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-[#234D89]/95 via-[#234D89]/90 to-[#E73336]/40" />

      <div className="relative z-10 container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Chamada + botões */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center lg:text-left"
          >
            <span className="inline-block text-sm font-bold uppercase tracking-[0.2em] text-[#E73336] mb-6 bg-white/10 px-5 py-2 rounded-full">
              Não perca tempo
            </span>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white mb-6 leading-tight">
              Solicite seu orçamento{" "}
              <span className="text-[#E73336]">agora mesmo</span>
            </h2>
            <p className="text-white/80 text-base sm:text-lg mb-10 leading-relaxed lg:max-w-lg">
              Transforme seus materiais impressos em peças de alto impacto. Fale com nossos especialistas e descubra a diferença da qualidade Finegraf.
            </p>

            {/* Mesmo py, mesmo text-size e nowrap nos dois: sem isso o rótulo
                longo quebrava em duas linhas e os botões saíam desalinhados. */}
            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 justify-center lg:justify-start items-stretch">
              <motion.a
                href={WHATSAPP_QUOTE_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-cta-button"
                whileHover={{ scale: 1.05, boxShadow: "0 20px 40px rgba(231, 51, 54, 0.4)" }}
                whileTap={{ scale: 0.98 }}
                className="group inline-flex items-center justify-center gap-2.5 whitespace-nowrap px-7 py-4 bg-[#E73336] text-white font-bold text-sm uppercase tracking-wide rounded-full hover:bg-[#BD2A2C] transition-all shadow-xl shadow-[#E73336]/30"
              >
                <WhatsappLogo weight="fill" size={22} className="group-hover:animate-pulse" />
                Falar Agora
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </motion.a>

              <motion.a
                href={COMPANY.phoneHref}
                whileHover={{ scale: 1.02 }}
                className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap px-7 py-4 bg-white/10 backdrop-blur-sm text-white font-bold text-sm uppercase tracking-wide rounded-full hover:bg-white/20 transition-all border border-white/20"
              >
                <Phone weight="fill" size={22} />
                {COMPANY.phone}
              </motion.a>
            </div>
          </motion.div>

          {/* Mapa + endereço */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            viewport={{ once: true }}
            data-testid="final-cta-map"
            className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-3xl p-4 sm:p-5"
          >
            <div className="rounded-2xl overflow-hidden aspect-[4/3] sm:aspect-[16/10] bg-[#234D89]">
              <iframe
                src={address.embedUrl}
                title={`Mapa da localização da Finegraf: ${address.full}`}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                className="w-full h-full border-0"
              />
            </div>

            <div className="flex items-start gap-3 mt-5 px-1">
              <MapPin size={22} weight="fill" className="text-[#E73336] flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-white font-semibold leading-snug">{address.street}</p>
                <p className="text-white/70 text-sm leading-snug">
                  {address.district} — {address.city}
                </p>
                <p className="text-white/70 text-sm leading-snug">CEP {address.zip}</p>
              </div>
            </div>

            <a
              href={address.directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-directions"
              className="inline-flex items-center gap-2 mt-4 px-1 text-sm font-semibold text-white/90 hover:text-[#E73336] transition-colors"
            >
              <NavigationArrow size={18} weight="fill" />
              Ver rota no Google Maps
              <ArrowRight size={15} />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
